/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Duration } from 'date-fns';
import isValid from 'date-fns/fp/isValid';
import isWithinInterval from 'date-fns/fp/isWithinInterval';
import sub from 'date-fns/fp/sub';

export const isWithinLast =
	(duration: Duration) =>
	(date: Date | number | null | undefined): boolean => {
		if (!isValid(date)) return false;
		const end = Date.now();
		const start = sub(duration)(end);
		// `isValid` precludes a nullable date.
		// oxlint-disable-next-line typescript/no-non-null-assertion
		return isWithinInterval({ start, end })(date!);
	};
